import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "condicional-list-page condicional-list-table"
  }, [_c('FilterFields', {
    attrs: {
      "fields": _vm.filterFields
    }
  }), _c('div', {
    staticClass: "condicional-report-grid mb-4"
  }, [_c('button', {
    staticClass: "condicional-report-card",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.aplicarFiltroStatus(2);
      }
    }
  }, [_c('span', [_vm._v("Condicionais em aberto")]), _c('strong', [_vm._v(_vm._s(_vm.relatorio.condicionais_em_aberto || 0))])]), _c('button', {
    staticClass: "condicional-report-card",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.aplicarFiltroVencidas
    }
  }, [_c('span', [_vm._v("Condicionais vencidas")]), _c('strong', [_vm._v(_vm._s(_vm.relatorio.condicionais_vencidas || 0))])]), _c('button', {
    staticClass: "condicional-report-card",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('condicionalProdutosRelatorio');
      }
    }
  }, [_c('span', [_vm._v("Peças em condicional")]), _c('strong', [_vm._v(_vm._s(_vm.numberToReal(_vm.relatorio.quantidade_pecas_em_aberto || 0, 4)))])]), _c('button', {
    staticClass: "condicional-report-card",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('condicionalProdutosRelatorio');
      }
    }
  }, [_c('span', [_vm._v("Valor em aberto")]), _c('strong', [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.relatorio.valor_total_em_aberto || 0, 2)) + " ")])])]), _c('TableApp', {
    ref: "condicionalList",
    attrs: {
      "titulo": "Condicional de Mercadorias",
      "api-url": "/condicional-mercadorias/lista",
      "fields": _vm.fields,
      "classFilterColumn": "numero",
      "perPage": 30,
      "fixedLayout": true
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field === 'numero' ? _c('span', [_c('strong', [_vm._v(_vm._s(props.rowData.numero))])]) : _vm._e(), props.field === 'cliente' ? _c('span', [_vm._v(" " + _vm._s(_vm.nomeCliente(props.rowData)) + " ")]) : _vm._e(), props.field === 'cnpj_cpf' ? _c('span', [_vm._v(" " + _vm._s(props.rowData.cnpj_cpf ? _vm.formatCpfCnpj(props.rowData.cnpj_cpf) : "-") + " ")]) : _vm._e(), props.field === 'vendedor' ? _c('span', [_vm._v(" " + _vm._s(props.rowData.vendedor || "-") + " ")]) : _vm._e(), props.field === 'data_saida' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.data_saida)) + " ")]) : _vm._e(), props.field === 'data_limite_retorno' ? _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.data_limite_retorno)) + " ")]) : _vm._e(), props.field === 'dias_em_aberto' ? _c('span', [_vm._v(" " + _vm._s(_vm.diasEmAberto(props.rowData)) + " ")]) : _vm._e(), props.field === 'quantidade_total_enviada' ? _c('span', [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.quantidade_total_enviada, 4)) + " ")]) : _vm._e(), props.field === 'valor_total_enviado' ? _c('span', [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.valor_total_enviado, 2)) + " ")]) : _vm._e(), props.field === 'status' ? _c('span', [_c('CondicionalStatusBadge', {
          attrs: {
            "status": props.rowData.status
          }
        })], 1) : _vm._e(), props.field === 'actions' ? _c('span', [_c('div', {
          staticClass: "action-buttons"
        }, [_vm.temPermissaoCondicional ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Visualizar',
            expression: "'Visualizar'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.visualizar(props.rowData);
            }
          }
        }, [_c('Eye', {
          attrs: {
            "size": 12
          }
        })], 1) : _vm._e(), _vm.temPermissaoCondicional && _vm.podeEditarCondicional(props.rowData) ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Editar',
            expression: "'Editar'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.editar(props.rowData);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 12
          }
        })], 1) : _vm._e(), _vm.temPermissaoCondicional && _vm.podeImprimirCondicional(props.rowData) ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Imprimir',
            expression: "'Imprimir'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-icon mr-2 condicional-print-action",
          on: {
            "click": function click($event) {
              return _vm.abrirModalImpressao(props.rowData);
            }
          }
        }, [_c('Printer', {
          attrs: {
            "size": 12
          }
        })], 1) : _vm._e(), _vm.temPermissaoCondicional && Number(props.rowData.status) === 1 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Confirmar saída',
            expression: "'Confirmar saída'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-primary btn-hover-primary btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.confirmarSaida(props.rowData);
            }
          }
        }, [_c('Check', {
          attrs: {
            "size": 12
          }
        })], 1) : _vm._e(), _vm.temPermissaoCondicional && _vm.podeProcessarRetorno(props.rowData) ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Processar retorno',
            expression: "'Processar retorno'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-warning btn-hover-warning btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.abrirRetorno(props.rowData);
            }
          }
        }, [_c('Undo', {
          attrs: {
            "size": 12
          }
        })], 1) : _vm._e(), _vm.temPermissaoCondicional && (Number(props.rowData.status) === 1 || Number(props.rowData.status) === 2) ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Cancelar',
            expression: "'Cancelar'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.cancelar(props.rowData);
            }
          }
        }, [_c('Close', {
          attrs: {
            "size": 12
          }
        })], 1) : _vm._e()])]) : _vm._e()];
      }
    }])
  }, [_c('template', {
    slot: "toolbar-actions"
  }, [_vm.temPermissaoCondicional ? _c('button', {
    staticClass: "btn btn-dark font-weight-bolder font-size-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'condicionalMercadoriasNova'
        });
      }
    }
  }, [_vm._v(" Nova Condicional ")]) : _vm._e()])], 2), _c('b-modal', {
    attrs: {
      "id": "condicionalDetalhes",
      "title": "Condicional de Mercadorias",
      "size": "xl",
      "centered": "",
      "hide-footer": ""
    }
  }, [_vm.condicionalSelecionada ? _c('div', [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Número")]), _c('p', [_vm._v(_vm._s(_vm.condicionalSelecionada.numero))])]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Cliente")]), _c('p', [_vm._v(_vm._s(_vm.nomeCliente(_vm.condicionalSelecionada)))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Vendedor")]), _c('p', [_vm._v(_vm._s(_vm.nomeVendedor(_vm.condicionalSelecionada)))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Status")]), _c('p', [_c('CondicionalStatusBadge', {
    attrs: {
      "status": _vm.condicionalSelecionada.status
    }
  })], 1)]), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Saída")]), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.condicionalSelecionada.data_saida)))])]), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Limite")]), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.condicionalSelecionada.data_limite_retorno)))])]), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Enviado")]), _c('p', [_vm._v(" " + _vm._s(_vm.numberToReal(_vm.condicionalSelecionada.quantidade_total_enviada, 4)) + " ")])]), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Vendido")]), _c('p', [_vm._v(" " + _vm._s(_vm.numberToReal(_vm.condicionalSelecionada.quantidade_total_vendida, 4)) + " ")])]), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Devolvido")]), _c('p', [_vm._v(" " + _vm._s(_vm.numberToReal(_vm.condicionalSelecionada.quantidade_total_devolvida, 4)) + " ")])]), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Pendente")]), _c('p', [_vm._v(_vm._s(_vm.numberToReal(_vm.quantidadePendenteCondicional, 4)))])])], 1), _c('h5', {
    staticClass: "font-weight-bold mb-3"
  }, [_vm._v("Itens")]), _c('div', {
    staticClass: "table-responsive mb-5"
  }, [_c('table', {
    staticClass: "table table-sm table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Produto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Enviada")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Vendida")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Devolvida")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Danificada")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Perdida")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Pendente")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor unitário")])])]), _c('tbody', _vm._l(_vm.condicionalSelecionada.itens || [], function (item) {
    return _c('tr', {
      key: item.id_condicional_mercadoria_item
    }, [_c('td', [_vm._v(_vm._s(_vm.descricaoProduto(item)))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(item.quantidade_enviada, 4)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(item.quantidade_vendida, 4)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(item.quantidade_devolvida, 4)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(item.quantidade_danificada, 4)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(item.quantidade_perdida, 4)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(_vm.quantidadePendente(item), 4)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.valorUnitarioItem(item), 2)) + " ")])]);
  }), 0)])]), _c('h5', {
    staticClass: "font-weight-bold mb-3"
  }, [_vm._v("Histórico")]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _c('th', [_vm._v("Movimento")]), _c('th', [_vm._v("Produto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Quantidade")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor")]), _c('th', [_vm._v("Observação")])])]), _c('tbody', [_vm._l(_vm.historicoCondicional, function (movimento) {
    return _c('tr', {
      key: movimento.id_condicional_mercadoria_movimento
    }, [_c('td', [_vm._v(_vm._s(_vm.formatDateTime(movimento.created_at)))]), _c('td', [_vm._v(_vm._s(_vm.movimentoTipoLabel(movimento.tipo)))]), _c('td', [_vm._v(_vm._s(_vm.descricaoProduto(movimento.item || {})))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(movimento.quantidade, 4)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(movimento.valor, 2)) + " ")]), _c('td', [_vm._v(_vm._s(movimento.observacao || "-"))])]);
  }), !_vm.historicoCondicional.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" Nenhum movimento registrado. ")])]) : _vm._e()], 2)])])], 1) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "condicionalRetorno",
      "title": "Processar retorno",
      "size": "xl",
      "centered": "",
      "hide-footer": "",
      "no-close-on-backdrop": ""
    }
  }, [_vm.retornoCondicional ? _c('div', [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('strong', [_vm._v("Número")]), _c('p', [_vm._v(_vm._s(_vm.retornoCondicional.numero))])]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('strong', [_vm._v("Cliente")]), _c('p', [_vm._v(_vm._s(_vm.nomeCliente(_vm.retornoCondicional)))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Status")]), _c('p', [_c('CondicionalStatusBadge', {
    attrs: {
      "status": _vm.retornoCondicional.status
    }
  })], 1)]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Saldo editável")]), _c('p', [_vm._v(_vm._s(_vm.numberToReal(_vm.retornoTotais.pendenteOriginal, 4)))])])], 1), _c('div', {
    staticClass: "retorno-toolbar mb-3"
  }, [_c('div', {
    staticClass: "retorno-toolbar-main"
  }, [_c('div', {
    staticClass: "retorno-toolbar-actions"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-primary mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.preencherRetorno('quantidade_vendida');
      }
    }
  }, [_vm._v(" Vender tudo ")]), _c('button', {
    staticClass: "btn btn-sm btn-outline-success mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.preencherRetorno('quantidade_devolvida');
      }
    }
  }, [_vm._v(" Devolver tudo ")]), _c('button', {
    staticClass: "btn btn-sm btn-outline-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.marcarNaoLancadosComoVendidos
    }
  }, [_vm._v(" Vender não selecionados ")])]), _c('strong', [_vm._v("Total vendido: R$ " + _vm._s(_vm.numberToReal(_vm.retornoTotais.valorVendido, 2)))])]), _c('div', {
    staticClass: "retorno-leitor-card"
  }, [_c('span', {
    staticClass: "retorno-leitor-label"
  }, [_vm._v("Leitura rápida")]), _c('div', {
    staticClass: "retorno-leitor"
  }, [_c('div', {
    staticClass: "btn-group btn-group-sm mr-2",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn",
    class: _vm.retornoLeituraModo === 'quantidade_devolvida' ? 'btn-success' : 'btn-outline-success',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selecionarModoLeitura('quantidade_devolvida');
      }
    }
  }, [_vm._v(" Devolver ")]), _c('button', {
    staticClass: "btn",
    class: _vm.retornoLeituraModo === 'quantidade_danificada' ? 'btn-warning' : 'btn-outline-warning',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.selecionarModoLeitura('quantidade_danificada');
      }
    }
  }, [_vm._v(" Avariar ")])]), _c('b-form-input', {
    ref: "retornoCodigoInput",
    staticClass: "retorno-codigo-input",
    attrs: {
      "size": "sm",
      "placeholder": "Código ou referência"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.lancarCodigoRetorno.apply(null, arguments);
      }
    },
    model: {
      value: _vm.retornoCodigoLeitura,
      callback: function callback($$v) {
        _vm.retornoCodigoLeitura = $$v;
      },
      expression: "retornoCodigoLeitura"
    }
  }), _c('button', {
    staticClass: "btn btn-sm btn-primary ml-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.lancarCodigoRetorno
    }
  }, [_vm._v(" Lançar ")])], 1)])]), _vm.retornoErros.length ? _c('b-alert', {
    staticClass: "mb-3",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.retornoErros[0]) + " ")]) : _vm._e(), _c('div', {
    staticClass: "table-responsive mb-4"
  }, [_c('table', {
    staticClass: "table table-sm table-striped retorno-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Produto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Editável")]), _c('th', [_vm._v("Vender")]), _c('th', [_vm._v("Devolver")]), _c('th', [_vm._v("Avariar")]), _c('th', [_vm._v("Perder")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Manter")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Saldo")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total vendido")])])]), _c('tbody', _vm._l(_vm.retornoItens, function (item) {
    return _c('tr', {
      key: item.id_condicional_mercadoria_item,
      class: {
        'table-danger': Boolean(_vm.retornoItemErro(item))
      }
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(item.produto))]), _c('small', {
      staticClass: "d-block text-muted"
    }, [_vm._v(" Código: " + _vm._s(item.codigo || "-") + ", Referência: " + _vm._s(item.referencia || "-") + " ")])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(item.quantidade_pendente_original, 4)) + " ")]), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.0001"
      },
      on: {
        "input": function input($event) {
          return _vm.normalizarRetornoItem(item, 'quantidade_vendida');
        }
      },
      model: {
        value: item.quantidade_vendida,
        callback: function callback($$v) {
          _vm.$set(item, "quantidade_vendida", _vm._n($$v));
        },
        expression: "item.quantidade_vendida"
      }
    })], 1), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.0001"
      },
      on: {
        "input": function input($event) {
          return _vm.normalizarRetornoItem(item, 'quantidade_devolvida');
        }
      },
      model: {
        value: item.quantidade_devolvida,
        callback: function callback($$v) {
          _vm.$set(item, "quantidade_devolvida", _vm._n($$v));
        },
        expression: "item.quantidade_devolvida"
      }
    })], 1), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.0001"
      },
      on: {
        "input": function input($event) {
          return _vm.normalizarRetornoItem(item, 'quantidade_danificada');
        }
      },
      model: {
        value: item.quantidade_danificada,
        callback: function callback($$v) {
          _vm.$set(item, "quantidade_danificada", _vm._n($$v));
        },
        expression: "item.quantidade_danificada"
      }
    })], 1), _c('td', [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.0001"
      },
      on: {
        "input": function input($event) {
          return _vm.normalizarRetornoItem(item, 'quantidade_perdida');
        }
      },
      model: {
        value: item.quantidade_perdida,
        callback: function callback($$v) {
          _vm.$set(item, "quantidade_perdida", _vm._n($$v));
        },
        expression: "item.quantidade_perdida"
      }
    })], 1), _c('td', {
      staticClass: "text-center"
    }, [_c('b-form-checkbox', {
      attrs: {
        "disabled": _vm.retornoItemPendente(item) <= 0
      },
      model: {
        value: item.manter_pendente,
        callback: function callback($$v) {
          _vm.$set(item, "manter_pendente", $$v);
        },
        expression: "item.manter_pendente"
      }
    })], 1), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(_vm.retornoItemPendente(item), 4)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.totalVendidoRetornoItem(item), 2)) + " ")])]);
  }), 0), _c('tfoot', [_c('tr', [_c('th', [_vm._v("Total")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(" " + _vm._s(_vm.numberToReal(_vm.retornoTotais.pendenteOriginal, 4)) + " ")]), _c('th', [_vm._v(_vm._s(_vm.numberToReal(_vm.retornoTotais.vendida, 4)))]), _c('th', [_vm._v(_vm._s(_vm.numberToReal(_vm.retornoTotais.devolvida, 4)))]), _c('th', [_vm._v(_vm._s(_vm.numberToReal(_vm.retornoTotais.danificada, 4)))]), _c('th', [_vm._v(_vm._s(_vm.numberToReal(_vm.retornoTotais.perdida, 4)))]), _c('th'), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(" " + _vm._s(_vm.numberToReal(_vm.retornoTotais.pendente, 4)) + " ")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.retornoTotais.valorVendido, 2)) + " ")])])])])]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light-primary font-weight-bold mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('condicionalRetorno');
      }
    }
  }, [_vm._v(" Voltar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": !_vm.retornoPodeProcessar
    },
    on: {
      "click": _vm.processarRetorno
    }
  }, [_vm._v(" Processar retorno ")])])], 1) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "condicionalImpressao",
      "title": "Imprimir condicional",
      "centered": "",
      "hide-footer": ""
    }
  }, [_vm.condicionalImpressao ? _c('div', [_c('p', {
    staticClass: "text-muted mb-4"
  }, [_vm._v(" Escolha o formato para a condicional "), _c('strong', [_vm._v(_vm._s(_vm.condicionalImpressao.numero))]), _vm._v(". ")]), _c('div', {
    staticClass: "condicional-print-options"
  }, [_c('button', {
    staticClass: "condicional-print-option",
    attrs: {
      "disabled": _vm.imprimindoCondicional
    },
    on: {
      "click": function click($event) {
        return _vm.imprimirCondicional('a4');
      }
    }
  }, [_c('span', {
    staticClass: "condicional-print-title"
  }, [_vm._v("A4 completo")]), _c('span', {
    staticClass: "condicional-print-description"
  }, [_vm._v(" Documento detalhado com resumo, itens, termos e assinaturas. ")])]), _c('button', {
    staticClass: "condicional-print-option",
    attrs: {
      "disabled": _vm.imprimindoCondicional
    },
    on: {
      "click": function click($event) {
        return _vm.imprimirCondicional('80');
      }
    }
  }, [_c('span', {
    staticClass: "condicional-print-title"
  }, [_vm._v("80 colunas")]), _c('span', {
    staticClass: "condicional-print-description"
  }, [_vm._v(" Via simplificada para impressora térmica ou conferência rápida. ")])])])]) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "condicionalProdutosRelatorio",
      "title": "Produtos em condicional",
      "size": "lg",
      "centered": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm table-striped condicional-produtos-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Produto")]), _c('th', [_vm._v("Nº condicionais")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Peças")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor em aberto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Condicionais")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Clientes")])])]), _c('tbody', [_vm._l(_vm.produtosEmCondicional, function (produto) {
    return _c('tr', {
      key: produto.id_produto
    }, [_c('td', {
      attrs: {
        "data-label": "Produto"
      }
    }, [_c('strong', [_vm._v(_vm._s(produto.produto || "-"))]), _c('small', {
      staticClass: "d-block text-muted"
    }, [_vm._v(" Código: " + _vm._s(produto.codigo || "-") + " ")])]), _c('td', {
      attrs: {
        "data-label": "Nº condicionais"
      }
    }, [_vm._v(" " + _vm._s(produto.numeros_condicionais || "-") + " ")]), _c('td', {
      staticClass: "text-right",
      attrs: {
        "data-label": "Peças"
      }
    }, [_vm._v(" " + _vm._s(_vm.numberToReal(produto.quantidade_em_aberto, 4)) + " ")]), _c('td', {
      staticClass: "text-right",
      attrs: {
        "data-label": "Valor em aberto"
      }
    }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(produto.valor_em_aberto, 2)) + " ")]), _c('td', {
      staticClass: "text-right",
      attrs: {
        "data-label": "Condicionais"
      }
    }, [_vm._v(" " + _vm._s(produto.condicionais) + " ")]), _c('td', {
      staticClass: "text-right",
      attrs: {
        "data-label": "Clientes"
      }
    }, [_vm._v(" " + _vm._s(produto.clientes) + " ")])]);
  }), !_vm.produtosEmCondicional.length ? _c('tr', {
    staticClass: "condicional-produtos-vazio"
  }, [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" Nenhum produto em condicional. ")])]) : _vm._e()], 2)])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };